<template>
  <z-dialog :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <div class="row">
        <div class="col-md-6">
          <z-input
            v-model="subject"
            name="subject"
            label="Subject"
            :inline="true"
          />
        </div>
        <div class="col-md-6">
          <input
            type="checkbox"
            id="isInactive"
            v-model="isInactive"
            class="z-checkbox-small"
          />
          <label for="isInactive" class="custom-is">inactive?</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <z-input v-model="type" name="type" label="Type" :inline="true" />
        </div>
        <div class="col-md-6">
          <input
            type="checkbox"
            id="isInvite"
            v-model="isInvite"
            class="z-checkbox-small"
          />
          <label for="isInvite" class="custom-is"
            >default invite message?</label
          >
        </div>
      </div>
      <z-editor v-model="body" @change="editorChanged" contentType="html" />
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-6">
          <span v-if="invalidMessage !== ''" class="custom-invalid">{{
            invalidMessage
          }}</span>
        </div>
        <div class="col-md-6">
          <div class="custom-buttons">
            <button class="btn btn-primary me-2" @click="performSave(false)">
              Save
            </button>
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZDialog from '@/Components/ZElements/Dialog'
import ZEditor from '@/Components/ZElements/Editor'
import ZInput from '@/Components/ZElements/Input'
export default {
  name: 'user-messages-dialog',
  components: {
    ZDialog,
    ZEditor,
    ZInput,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-xl',
      invalidMessage: '',
    }
  },
  emits: ['close', 'saved'],
  computed: {
    ...mapGetters('users', ['user']),
    ...mapGetters('messages', ['cannedmessage']),
    isVisible() {
      return this.show !== null
    },
    title() {
      let _title = 'Edit Canned Message'
      if (this.show) {
        if (this.show.isAdd) {
          _title = 'Add Canned Message'
        }
      }
      return _title
    },
    currentOrganization() {
      let _data = null
      if (this.user) {
        _data = this.user.detail.organization
      }
      return _data
    },
    body: {
      get() {
        let _data = ''
        if (this.cannedmessage) {
          _data = this.cannedmessage.body
        }
        return _data
      },
      set(value) {
        this.setCannedMessageData({
          name: 'body',
          value: value,
        })
      },
    },
    subject: {
      get() {
        let _data = ''
        if (this.cannedmessage) {
          _data = this.cannedmessage.subject
        }
        return _data
      },
      set(value) {
        this.setCannedMessageData({
          name: 'subject',
          value: value,
        })
      },
    },
    type: {
      get() {
        let _data = ''
        if (this.cannedmessage) {
          _data = this.cannedmessage.type
        }
        return _data
      },
      set(value) {
        this.setCannedMessageData({
          name: 'type',
          value: value,
        })
      },
    },
    isInactive: {
      get() {
        let _data = ''
        if (this.cannedmessage) {
          _data = this.cannedmessage.isInactive
        }
        return _data
      },
      set(value) {
        this.setCannedMessageData({
          name: 'isInactive',
          value: value,
        })
      },
    },
    isInvite: {
      get() {
        let _data = ''
        if (this.cannedmessage) {
          _data = this.cannedmessage.isInvite
        }
        return _data
      },
      set(value) {
        this.setCannedMessageData({
          name: 'isInvite',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('messages', ['setCannedMessageData', 'saveCannedMessage']),
    close() {
      this.$emit('close')
    },
    editorChanged() {},
    async performSave() {
      console.log('Saving Canned Message', this.cannedmessage)
      await this.saveCannedMessage(this.cannedmessage)
      this.$emit('saved')
    },
  },
}
</script>
<style scoped>
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-is {
  margin-left: 5px;
}
</style>
